import { patternTelInput } from '@helper/functions';

export default function InputNumber({
  name,
  title,
  required,
  placeholder,
  value,
  errors,
  touched,
  handleChange,
  disabled,
  handleBlur,
  onFocus,
}) {
  return (
    <div className="flex flex-col items-start gap-1.5 w-full relative">
      <div className="flex flex-row items-center gap-1">
        <p className="titleInput">{title}</p>
        {required && <p className="requiredText">اجباری</p>}
      </div>
      <div
        className={`
            ${errors && touched ? 'border-error' : 'border-light-grey dark:border-blackFont-700'}
           disabled:bg-light-grey/50 dark:disabled:bg-blackFont-800/60 border-[1px] rounded-lg py-2 px-4 h-[48px] w-full placeholder:text-text-normal/70 dark:placeholder:text-blackFont-400 placeholder:font-light text-text-hard dark:text-white text-base transition-all flex items-center justify-between gap-2 relative bg-white dark:bg-blackFont-800`}
      >
        <input
          onBlur={handleBlur}
          onFocus={onFocus}
          disabled={disabled}
          name={name}
          onChange={handleChange}
          value={value}
          type="tel"
          className="w-full h-full bg-transparent appearance-none text-text-hard dark:text-white placeholder:text-text-normal/70 dark:placeholder:text-blackFont-400"
          onInput={patternTelInput}
          placeholder={placeholder}
        />
      </div>

      {errors && touched && <p className="absolute -bottom-5 text-xs text-error">{errors}</p>}
    </div>
  );
}
